import api from '../../../services/api';

export const SkillsHTTP = {
  get: (params = {}) => api.get('/skills', {params}),
  create: (payload = {}) => api.post('/skills', payload),
  update: (id = '', params = {}) => api.put(`/skills/${id}`, params),
};
